import React, { Component } from 'react';
import i18n from 'app/common/i18n';
import CircularProgress from '@mui/material/CircularProgress';

class Loading extends Component {
  render() {
    return (
      <div
        style={{
          margin: '0 auto',
          padding: '2em',
          maxWidth: 400,
          textAlign: 'center'
        }}
      >
        <CircularProgress size={80} style={{ marginBottom: '2em' }} />
        <br />
        <strong>{this.props.i18n('Loading... please wait')}</strong>
      </div>
    );
  }
}

export default i18n(Loading);